import React from 'react';
import ReactDOM from 'react-dom';
import Application from './src';
import { unregister } from './service-worker';

const element = document.querySelector('#skulman');

ReactDOM.render(<Application />, element);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
